module.exports = __webpack_public_path__ + "static/img/img-fa2.86deb67.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-fa2.png
// module id = jFJT
// module chunks = 0